export interface Role {
  id: number;
  name: RoleNames | string;
  code: string;
}

export enum RoleNames {
  Member = "TAG",
  Captain = "CSK"
}
